/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GuestRouteImport } from './routes/guest'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GuestIndexRouteImport } from './routes/guest/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as GuestPinRouteImport } from './routes/guest/pin'
import { Route as AdminSeatingRouteImport } from './routes/admin/seating'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminKartenliebeDatenRouteImport } from './routes/admin/kartenliebe-daten'
import { Route as AdminInvitationCardsRouteImport } from './routes/admin/invitation-cards'
import { Route as AdminGalleryRouteImport } from './routes/admin/gallery'
import { Route as AdminContentRouteImport } from './routes/admin/content'
import { Route as GuestLogged_inPinRouteImport } from './routes/guest/logged_in.$pin'
import { Route as AdminGuestIdRouteImport } from './routes/admin/guest.$id'
import { Route as GuestLogged_inPinIndexRouteImport } from './routes/guest/logged_in.$pin.index'
import { Route as GuestLogged_inPinRsvpRouteImport } from './routes/guest/logged_in.$pin.rsvp'
import { Route as GuestLogged_inPinPhotosRouteImport } from './routes/guest/logged_in.$pin.photos'
import { Route as GuestLogged_inPinInvitationRouteImport } from './routes/guest/logged_in.$pin.invitation'

const GuestRoute = GuestRouteImport.update({
  id: '/guest',
  path: '/guest',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestIndexRoute = GuestIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestPinRoute = GuestPinRouteImport.update({
  id: '/pin',
  path: '/pin',
  getParentRoute: () => GuestRoute,
} as any)
const AdminSeatingRoute = AdminSeatingRouteImport.update({
  id: '/admin/seating',
  path: '/admin/seating',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKartenliebeDatenRoute = AdminKartenliebeDatenRouteImport.update({
  id: '/admin/kartenliebe-daten',
  path: '/admin/kartenliebe-daten',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvitationCardsRoute = AdminInvitationCardsRouteImport.update({
  id: '/admin/invitation-cards',
  path: '/admin/invitation-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGalleryRoute = AdminGalleryRouteImport.update({
  id: '/admin/gallery',
  path: '/admin/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContentRoute = AdminContentRouteImport.update({
  id: '/admin/content',
  path: '/admin/content',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestLogged_inPinRoute = GuestLogged_inPinRouteImport.update({
  id: '/logged_in/$pin',
  path: '/logged_in/$pin',
  getParentRoute: () => GuestRoute,
} as any)
const AdminGuestIdRoute = AdminGuestIdRouteImport.update({
  id: '/admin/guest/$id',
  path: '/admin/guest/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestLogged_inPinIndexRoute = GuestLogged_inPinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GuestLogged_inPinRoute,
} as any)
const GuestLogged_inPinRsvpRoute = GuestLogged_inPinRsvpRouteImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => GuestLogged_inPinRoute,
} as any)
const GuestLogged_inPinPhotosRoute = GuestLogged_inPinPhotosRouteImport.update({
  id: '/photos',
  path: '/photos',
  getParentRoute: () => GuestLogged_inPinRoute,
} as any)
const GuestLogged_inPinInvitationRoute =
  GuestLogged_inPinInvitationRouteImport.update({
    id: '/invitation',
    path: '/invitation',
    getParentRoute: () => GuestLogged_inPinRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/guest': typeof GuestRouteWithChildren
  '/admin/content': typeof AdminContentRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/invitation-cards': typeof AdminInvitationCardsRoute
  '/admin/kartenliebe-daten': typeof AdminKartenliebeDatenRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/seating': typeof AdminSeatingRoute
  '/guest/pin': typeof GuestPinRoute
  '/admin/': typeof AdminIndexRoute
  '/guest/': typeof GuestIndexRoute
  '/admin/guest/$id': typeof AdminGuestIdRoute
  '/guest/logged_in/$pin': typeof GuestLogged_inPinRouteWithChildren
  '/guest/logged_in/$pin/invitation': typeof GuestLogged_inPinInvitationRoute
  '/guest/logged_in/$pin/photos': typeof GuestLogged_inPinPhotosRoute
  '/guest/logged_in/$pin/rsvp': typeof GuestLogged_inPinRsvpRoute
  '/guest/logged_in/$pin/': typeof GuestLogged_inPinIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/content': typeof AdminContentRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/invitation-cards': typeof AdminInvitationCardsRoute
  '/admin/kartenliebe-daten': typeof AdminKartenliebeDatenRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/seating': typeof AdminSeatingRoute
  '/guest/pin': typeof GuestPinRoute
  '/admin': typeof AdminIndexRoute
  '/guest': typeof GuestIndexRoute
  '/admin/guest/$id': typeof AdminGuestIdRoute
  '/guest/logged_in/$pin/invitation': typeof GuestLogged_inPinInvitationRoute
  '/guest/logged_in/$pin/photos': typeof GuestLogged_inPinPhotosRoute
  '/guest/logged_in/$pin/rsvp': typeof GuestLogged_inPinRsvpRoute
  '/guest/logged_in/$pin': typeof GuestLogged_inPinIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/guest': typeof GuestRouteWithChildren
  '/admin/content': typeof AdminContentRoute
  '/admin/gallery': typeof AdminGalleryRoute
  '/admin/invitation-cards': typeof AdminInvitationCardsRoute
  '/admin/kartenliebe-daten': typeof AdminKartenliebeDatenRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/seating': typeof AdminSeatingRoute
  '/guest/pin': typeof GuestPinRoute
  '/admin/': typeof AdminIndexRoute
  '/guest/': typeof GuestIndexRoute
  '/admin/guest/$id': typeof AdminGuestIdRoute
  '/guest/logged_in/$pin': typeof GuestLogged_inPinRouteWithChildren
  '/guest/logged_in/$pin/invitation': typeof GuestLogged_inPinInvitationRoute
  '/guest/logged_in/$pin/photos': typeof GuestLogged_inPinPhotosRoute
  '/guest/logged_in/$pin/rsvp': typeof GuestLogged_inPinRsvpRoute
  '/guest/logged_in/$pin/': typeof GuestLogged_inPinIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/guest'
    | '/admin/content'
    | '/admin/gallery'
    | '/admin/invitation-cards'
    | '/admin/kartenliebe-daten'
    | '/admin/login'
    | '/admin/seating'
    | '/guest/pin'
    | '/admin/'
    | '/guest/'
    | '/admin/guest/$id'
    | '/guest/logged_in/$pin'
    | '/guest/logged_in/$pin/invitation'
    | '/guest/logged_in/$pin/photos'
    | '/guest/logged_in/$pin/rsvp'
    | '/guest/logged_in/$pin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/content'
    | '/admin/gallery'
    | '/admin/invitation-cards'
    | '/admin/kartenliebe-daten'
    | '/admin/login'
    | '/admin/seating'
    | '/guest/pin'
    | '/admin'
    | '/guest'
    | '/admin/guest/$id'
    | '/guest/logged_in/$pin/invitation'
    | '/guest/logged_in/$pin/photos'
    | '/guest/logged_in/$pin/rsvp'
    | '/guest/logged_in/$pin'
  id:
    | '__root__'
    | '/'
    | '/guest'
    | '/admin/content'
    | '/admin/gallery'
    | '/admin/invitation-cards'
    | '/admin/kartenliebe-daten'
    | '/admin/login'
    | '/admin/seating'
    | '/guest/pin'
    | '/admin/'
    | '/guest/'
    | '/admin/guest/$id'
    | '/guest/logged_in/$pin'
    | '/guest/logged_in/$pin/invitation'
    | '/guest/logged_in/$pin/photos'
    | '/guest/logged_in/$pin/rsvp'
    | '/guest/logged_in/$pin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GuestRoute: typeof GuestRouteWithChildren
  AdminContentRoute: typeof AdminContentRoute
  AdminGalleryRoute: typeof AdminGalleryRoute
  AdminInvitationCardsRoute: typeof AdminInvitationCardsRoute
  AdminKartenliebeDatenRoute: typeof AdminKartenliebeDatenRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminSeatingRoute: typeof AdminSeatingRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminGuestIdRoute: typeof AdminGuestIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/guest': {
      id: '/guest'
      path: '/guest'
      fullPath: '/guest'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/': {
      id: '/guest/'
      path: '/'
      fullPath: '/guest/'
      preLoaderRoute: typeof GuestIndexRouteImport
      parentRoute: typeof GuestRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/pin': {
      id: '/guest/pin'
      path: '/pin'
      fullPath: '/guest/pin'
      preLoaderRoute: typeof GuestPinRouteImport
      parentRoute: typeof GuestRoute
    }
    '/admin/seating': {
      id: '/admin/seating'
      path: '/admin/seating'
      fullPath: '/admin/seating'
      preLoaderRoute: typeof AdminSeatingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kartenliebe-daten': {
      id: '/admin/kartenliebe-daten'
      path: '/admin/kartenliebe-daten'
      fullPath: '/admin/kartenliebe-daten'
      preLoaderRoute: typeof AdminKartenliebeDatenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/invitation-cards': {
      id: '/admin/invitation-cards'
      path: '/admin/invitation-cards'
      fullPath: '/admin/invitation-cards'
      preLoaderRoute: typeof AdminInvitationCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/gallery': {
      id: '/admin/gallery'
      path: '/admin/gallery'
      fullPath: '/admin/gallery'
      preLoaderRoute: typeof AdminGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/content': {
      id: '/admin/content'
      path: '/admin/content'
      fullPath: '/admin/content'
      preLoaderRoute: typeof AdminContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/logged_in/$pin': {
      id: '/guest/logged_in/$pin'
      path: '/logged_in/$pin'
      fullPath: '/guest/logged_in/$pin'
      preLoaderRoute: typeof GuestLogged_inPinRouteImport
      parentRoute: typeof GuestRoute
    }
    '/admin/guest/$id': {
      id: '/admin/guest/$id'
      path: '/admin/guest/$id'
      fullPath: '/admin/guest/$id'
      preLoaderRoute: typeof AdminGuestIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest/logged_in/$pin/': {
      id: '/guest/logged_in/$pin/'
      path: '/'
      fullPath: '/guest/logged_in/$pin/'
      preLoaderRoute: typeof GuestLogged_inPinIndexRouteImport
      parentRoute: typeof GuestLogged_inPinRoute
    }
    '/guest/logged_in/$pin/rsvp': {
      id: '/guest/logged_in/$pin/rsvp'
      path: '/rsvp'
      fullPath: '/guest/logged_in/$pin/rsvp'
      preLoaderRoute: typeof GuestLogged_inPinRsvpRouteImport
      parentRoute: typeof GuestLogged_inPinRoute
    }
    '/guest/logged_in/$pin/photos': {
      id: '/guest/logged_in/$pin/photos'
      path: '/photos'
      fullPath: '/guest/logged_in/$pin/photos'
      preLoaderRoute: typeof GuestLogged_inPinPhotosRouteImport
      parentRoute: typeof GuestLogged_inPinRoute
    }
    '/guest/logged_in/$pin/invitation': {
      id: '/guest/logged_in/$pin/invitation'
      path: '/invitation'
      fullPath: '/guest/logged_in/$pin/invitation'
      preLoaderRoute: typeof GuestLogged_inPinInvitationRouteImport
      parentRoute: typeof GuestLogged_inPinRoute
    }
  }
}

interface GuestLogged_inPinRouteChildren {
  GuestLogged_inPinInvitationRoute: typeof GuestLogged_inPinInvitationRoute
  GuestLogged_inPinPhotosRoute: typeof GuestLogged_inPinPhotosRoute
  GuestLogged_inPinRsvpRoute: typeof GuestLogged_inPinRsvpRoute
  GuestLogged_inPinIndexRoute: typeof GuestLogged_inPinIndexRoute
}

const GuestLogged_inPinRouteChildren: GuestLogged_inPinRouteChildren = {
  GuestLogged_inPinInvitationRoute: GuestLogged_inPinInvitationRoute,
  GuestLogged_inPinPhotosRoute: GuestLogged_inPinPhotosRoute,
  GuestLogged_inPinRsvpRoute: GuestLogged_inPinRsvpRoute,
  GuestLogged_inPinIndexRoute: GuestLogged_inPinIndexRoute,
}

const GuestLogged_inPinRouteWithChildren =
  GuestLogged_inPinRoute._addFileChildren(GuestLogged_inPinRouteChildren)

interface GuestRouteChildren {
  GuestPinRoute: typeof GuestPinRoute
  GuestIndexRoute: typeof GuestIndexRoute
  GuestLogged_inPinRoute: typeof GuestLogged_inPinRouteWithChildren
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestPinRoute: GuestPinRoute,
  GuestIndexRoute: GuestIndexRoute,
  GuestLogged_inPinRoute: GuestLogged_inPinRouteWithChildren,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GuestRoute: GuestRouteWithChildren,
  AdminContentRoute: AdminContentRoute,
  AdminGalleryRoute: AdminGalleryRoute,
  AdminInvitationCardsRoute: AdminInvitationCardsRoute,
  AdminKartenliebeDatenRoute: AdminKartenliebeDatenRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminSeatingRoute: AdminSeatingRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminGuestIdRoute: AdminGuestIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
